(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["general-marquee"] && !Shopify.designMode) return;
  try {
    
  class GeneralMarquee extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const list = this.querySelector('ul');
      if (!list || this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const marqueeLength = list.querySelectorAll('li').length;

      list.insertAdjacentHTML('beforeEnd', list.innerHTML);
      list.insertAdjacentHTML('beforeEnd', list.innerHTML);

      const items = list.querySelectorAll('li');
      items.forEach((item, index) => {
        if (index >= marqueeLength) {
          item.setAttribute('aria-hidden', 'true');
        }
      });

      // One loop = distance from the first item to its first clone, which includes the trailing gap
      // (scrollWidth of the original list did not, causing a jump each loop). Item padding and font size
      // change at md, so re-measure whenever the list is resized instead of fixing it at page load.
      const updateDistance = () => {
        if (!items[marqueeLength]) return;
        const distance = items[marqueeLength].offsetLeft - items[0].offsetLeft;
        list.style.setProperty('--general-marquee-distance', `${distance}px`);
      };
      updateDistance();
      if ('ResizeObserver' in window) new ResizeObserver(updateDistance).observe(list);

      const sectionId = this.dataset.sectionId;
      const direction = this.dataset.marqueeDirection;
      const keyframes =
        direction === 'right'
          ? `@keyframes general-marquee-animation-${sectionId} {
              from { transform: translateX(calc(var(--general-marquee-distance) * -1)); }
              to { transform: translateX(0); }
            }`
          : `@keyframes general-marquee-animation-${sectionId} {
              from { transform: translateX(0); }
              to { transform: translateX(calc(var(--general-marquee-distance) * -1)); }
            }`;

      const style = `
        <style>
          #general-marquee-${sectionId} ul {
            animation-name: general-marquee-animation-${sectionId};
            animation-duration: ${this.dataset.animationDuration}s;
          }
          ${keyframes}
        </style>
      `;

      this.insertAdjacentHTML('beforeBegin', style);
    }
  }

  if (!customElements.get('general-marquee')) {
    customElements.define('general-marquee', GeneralMarquee);
  }

  // Re-run when a section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('general-marquee').forEach((el) => {
      el.dataset.initialized = '';
      el.init();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
